import api from 'app/actions/api';
import i18n from 'app/i18n';


export const IDENTIFIERS_REQUEST = 'IDENTIFIERS_REQUEST';
export const IDENTIFIERS_SUCCESS = 'IDENTIFIERS_SUCCESS';
export const IDENTIFIERS_FAILURE = 'IDENTIFIERS_FAILURE';

const identifiersRequest = () => ({
  type: IDENTIFIERS_REQUEST,
});

const identifiersSuccess = data => ({
  type: IDENTIFIERS_SUCCESS,
  payload: data,
});

const identifiersFailure = errString => ({
  type: IDENTIFIERS_FAILURE,
  payload: { err: errString },
});


/**
* Запрос данных по идентификаторам
*/
export const fetchIdentifiers = id => async (dispatch) => {
  dispatch(identifiersRequest());
  try {
    const { data } = await api('cabinet/identifiers', 'get', { params: { student_id: id } });
    dispatch(identifiersSuccess(data));
  } catch (error) {
    dispatch(identifiersFailure(i18n.t('app:request_identifiers_failed')));
  }
};
